import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from '../components/common/Loader';
import { showToast } from '../utils/showToast';

const AuthCallback: React.FC = () => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // This hook observes the authentication state provided by AuthContext.
    // We wait until loading is complete before navigating.
    if (!isLoading) {
      if (isAuthenticated && user) {
        // ✅ Corrected navigation paths to match AppRoutes.tsx
        if (user.isAdmin) {
          showToast('✅ Admin login successful!', 'success');
          navigate('/dashboard/admin', { replace: true });
        } else if (user.role === 'mentor' && user.isApproved) {
          showToast('✅ Mentor login successful!', 'success');
          navigate('/dashboard/mentor', { replace: true });
        } else if (user.role === 'student' && user.isApproved) {
          showToast('✅ Student login successful!', 'success');
          navigate('/dashboard/student', { replace: true });
        } else if (user.role === 'student' && !user.isApproved) {
          // Changed 'info' to 'success' to align with your showToast types
          showToast('⚠️ Your account is pending mentor approval.', 'success');
          navigate('/login', { replace: true });
        }
      } else {
        // If not authenticated after loading, it means the login failed.
        showToast('❌ Google login failed. Please try again.', 'error');
        navigate('/login', { replace: true });
      }
    }
  }, [isAuthenticated, isLoading, user, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <Loader />
      <p className="mt-4 text-gray-600">Logging you in...</p>
    </div>
  );
};

export default AuthCallback;